import _ from "lodash";
import { Card, Color } from "../models/Splendor";
import { getCost } from "./utils";

export const ALL_CARDS: Card[] = [
  {
    id: 0,
    color: Color.White,
    cost: getCost(0, 1, 1, 1, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 1,
    color: Color.White,
    cost: getCost(0, 1, 2, 1, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 2,
    color: Color.White,
    cost: getCost(0, 2, 2, 0, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 3,
    color: Color.White,
    cost: getCost(3, 1, 0, 0, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 4,
    color: Color.White,
    cost: getCost(0, 0, 0, 2, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 5,
    color: Color.White,
    cost: getCost(0, 2, 0, 0, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 6,
    color: Color.White,
    cost: getCost(0, 3, 0, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 7,
    color: Color.White,
    cost: getCost(0, 0, 4, 0, 0),
    points: 1,
    tier: 'tier1',
  },
  {
    id: 8,
    color: Color.Black,
    cost: getCost(1, 1, 1, 1, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 9,
    color: Color.Black,
    cost: getCost(1, 2, 1, 1, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 10,
    color: Color.Black,
    cost: getCost(2, 2, 0, 1, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 11,
    color: Color.Black,
    cost: getCost(0, 0, 1, 3, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 12,
    color: Color.Black,
    cost: getCost(0, 0, 2, 1, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 13,
    color: Color.Black,
    cost: getCost(2, 0, 2, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 14,
    color: Color.Black,
    cost: getCost(0, 0, 3, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 15,
    color: Color.Black,
    cost: getCost(0, 4, 0, 0, 0),
    points: 1,
    tier: 'tier1',
  },
  {
    id: 16,
    color: Color.Blue,
    cost: getCost(1, 0, 1, 1, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 17,
    color: Color.Blue,
    cost: getCost(1, 0, 1, 2, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 18,
    color: Color.Blue,
    cost: getCost(1, 0, 2, 2, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 19,
    color: Color.Blue,
    cost: getCost(0, 1, 3, 1, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 20,
    color: Color.Blue,
    cost: getCost(1, 0, 0, 0, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 21,
    color: Color.Blue,
    cost: getCost(0, 0, 2, 0, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 22,
    color: Color.Blue,
    cost: getCost(0, 0, 0, 0, 3),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 23,
    color: Color.Blue,
    cost: getCost(0, 0, 0, 4, 0),
    points: 1,
    tier: 'tier1',
  },
  {
    id: 24,
    color: Color.Green,
    cost: getCost(1, 1, 0, 1, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 25,
    color: Color.Green,
    cost: getCost(1, 1, 0, 1, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 26,
    color: Color.Green,
    cost: getCost(0, 1, 0, 2, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 27,
    color: Color.Green,
    cost: getCost(1, 3, 1, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 28,
    color: Color.Green,
    cost: getCost(2, 1, 0, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 29,
    color: Color.Green,
    cost: getCost(0, 2, 0, 2, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 30,
    color: Color.Green,
    cost: getCost(0, 0, 0, 3, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 31,
    color: Color.Green,
    cost: getCost(0, 0, 0, 0, 4),
    points: 1,
    tier: 'tier1',
  },
  {
    id: 32,
    color: Color.Red,
    cost: getCost(1, 1, 1, 0, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 33,
    color: Color.Red,
    cost: getCost(2, 1, 1, 0, 1),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 34,
    color: Color.Red,
    cost: getCost(2, 0, 1, 0, 2),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 35,
    color: Color.Red,
    cost: getCost(1, 0, 0, 1, 3),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 36,
    color: Color.Red,
    cost: getCost(0, 2, 1, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 37,
    color: Color.Red,
    cost: getCost(2, 0, 0, 2, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 38,
    color: Color.Red,
    cost: getCost(3, 0, 0, 0, 0),
    points: 0,
    tier: 'tier1',
  },
  {
    id: 39,
    color: Color.Red,
    cost: getCost(4, 0, 0, 0, 0),
    points: 1,
    tier: 'tier1',
  },
  {
    id: 40,
    color: Color.Black,
    cost: getCost(3, 2, 2, 0, 0),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 41,
    color: Color.Black,
    cost: getCost(3, 0, 3, 0, 2),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 42,
    color: Color.Black,
    cost: getCost(0, 1, 4, 2, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 43,
    color: Color.Black,
    cost: getCost(0, 0, 5, 3, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 44,
    color: Color.Black,
    cost: getCost(5, 0, 0, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 45,
    color: Color.Black,
    cost: getCost(0, 0, 0, 0, 6),
    points: 3,
    tier: 'tier2',
  },
  {
    id: 46,
    color: Color.Blue,
    cost: getCost(0, 2, 2, 3, 0),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 47,
    color: Color.Blue,
    cost: getCost(0, 2, 3, 0, 3),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 48,
    color: Color.Blue,
    cost: getCost(5, 3, 0, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 49,
    color: Color.Blue,
    cost: getCost(2, 0, 0, 1, 4),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 50,
    color: Color.Blue,
    cost: getCost(0, 5, 0, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 51,
    color: Color.Blue,
    cost: getCost(0, 6, 0, 0, 0),
    points: 3,
    tier: 'tier2',
  },
  {
    id: 52,
    color: Color.White,
    cost: getCost(0, 0, 3, 2, 2),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 53,
    color: Color.White,
    cost: getCost(2, 3, 0, 3, 0),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 54,
    color: Color.White,
    cost: getCost(0, 0, 1, 4, 2),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 55,
    color: Color.White,
    cost: getCost(0, 0, 0, 5, 3),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 56,
    color: Color.White,
    cost: getCost(0, 0, 0, 5, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 57,
    color: Color.White,
    cost: getCost(6, 0, 0, 0, 0),
    points: 3,
    tier: 'tier2',
  },
  {
    id: 58,
    color: Color.Green,
    cost: getCost(3, 0, 2, 3, 0),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 59,
    color: Color.Green,
    cost: getCost(2, 3, 0, 0, 2),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 60,
    color: Color.Green,
    cost: getCost(4, 2, 0, 0, 1),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 61,
    color: Color.Green,
    cost: getCost(0, 5, 3, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 62,
    color: Color.Green,
    cost: getCost(0, 0, 5, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 63,
    color: Color.Green,
    cost: getCost(0, 0, 6, 0, 0),
    points: 3,
    tier: 'tier2',
  },
  {
    id: 64,
    color: Color.Red,
    cost: getCost(2, 0, 0, 2, 3),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 65,
    color: Color.Red,
    cost: getCost(0, 3, 0, 2, 3),
    points: 1,
    tier: 'tier2',
  },
  {
    id: 66,
    color: Color.Red,
    cost: getCost(1, 4, 2, 0, 0),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 67,
    color: Color.Red,
    cost: getCost(3, 0, 0, 0, 5),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 68,
    color: Color.Red,
    cost: getCost(0, 0, 0, 0, 5),
    points: 2,
    tier: 'tier2',
  },
  {
    id: 69,
    color: Color.Red,
    cost: getCost(0, 0, 0, 6, 0),
    points: 3,
    tier: 'tier2',
  },
  {
    id: 70,
    color: Color.Black,
    cost: getCost(3, 3, 5, 3, 0),
    points: 3,
    tier: 'tier3',
  },
  {
    id: 71,
    color: Color.Black,
    cost: getCost(0, 0, 0, 7, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 72,
    color: Color.Black,
    cost: getCost(0, 0, 3, 6, 3),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 73,
    color: Color.Black,
    cost: getCost(0, 0, 0, 7, 3),
    points: 5,
    tier: 'tier3',
  },
  {
    id: 74,
    color: Color.Blue,
    cost: getCost(3, 0, 3, 3, 5),
    points: 3,
    tier: 'tier3',
  },
  {
    id: 75,
    color: Color.Blue,
    cost: getCost(7, 0, 0, 0, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 76,
    color: Color.Blue,
    cost: getCost(6, 3, 0, 0, 3),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 77,
    color: Color.Blue,
    cost: getCost(7, 3, 0, 0, 0),
    points: 5,
    tier: 'tier3',
  },
  {
    id: 78,
    color: Color.White,
    cost: getCost(0, 3, 3, 5, 3),
    points: 3,
    tier: 'tier3',
  },
  {
    id: 79,
    color: Color.White,
    cost: getCost(0, 0, 0, 0, 7),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 80,
    color: Color.White,
    cost: getCost(3, 0, 0, 3, 6),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 81,
    color: Color.White,
    cost: getCost(3, 0, 0, 0, 7),
    points: 5,
    tier: 'tier3',
  },
  {
    id: 82,
    color: Color.Green,
    cost: getCost(5, 3, 0, 3, 3),
    points: 3,
    tier: 'tier3',
  },
  {
    id: 83,
    color: Color.Green,
    cost: getCost(0, 7, 0, 0, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 84,
    color: Color.Green,
    cost: getCost(3, 6, 3, 0, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 85,
    color: Color.Green,
    cost: getCost(0, 7, 3, 0, 0),
    points: 5,
    tier: 'tier3',
  },
  {
    id: 86,
    color: Color.Red,
    cost: getCost(3, 5, 3, 0, 3),
    points: 3,
    tier: 'tier3',
  },
  {
    id: 87,
    color: Color.Red,
    cost: getCost(0, 0, 7, 0, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 88,
    color: Color.Red,
    cost: getCost(0, 3, 6, 3, 0),
    points: 4,
    tier: 'tier3',
  },
  {
    id: 89,
    color: Color.Red,
    cost: getCost(0, 0, 7, 3, 0),
    points: 5,
    tier: 'tier3',
  },
];

export const DECK = _.groupBy(ALL_CARDS, 'tier') as unknown as Record<'tier1' | 'tier2' | 'tier3', Card[]>;
